<app-topbar></app-topbar>
<div class="container mr-top-56" *ngIf = "divReady">
			<!-- {{transactions | json}} -->
    <!-- Payment Detail -->
        <div class="common row mr-top-20 mr-bttm-68">
            <div class="col-md-12 prfl_data_side">
                <h1 class="mainhdng mr-bttm-30">Products & Subscriptions</h1>
                <div *ngIf="showNoRecord;else Subscription">
                    <div class="container cntremptyscrn">
                        <div class="row h-80 justify-content-center align-items-center">
                            <div class="common noproductsdiv text-center">
                                <img src="assets/images/products-n-subscriptions.png" class="noprdctimg">
                                <h3 class="noprdcrthdng">You don’t have any products yet </h3>
                                <p class="noprdcrt_subhdng">Click below to select a product susbscription</p>
                                <button routerLink = "/dashboard" class="getstrtd noinfobttn">Get Started</button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <ng-template #Subscription>
                    <div class="prflhdng mr-bttm-45">
                        <h6 class="pyhdng mr-bttm-5">Manage Subscriptions </h6>
                        <p class="text-left boxpara">Manage payments, recurring billing, or cancel your subscription.</p>
                    </div>
                    <div class="prflhdng mr-bttm-45 alert alert-danger" *ngIf = "unAllotedLicense">
                        <p class="text-left boxpara">You have {{unAllotedLicense}} unassigned {{unAllotedLicense > 1 ? 'licences' : 'licence'}}, <a href="#" routerLink = "/allot-license">Click here</a> to assign them to {{unAllotedLicense > 1 ? 'stores' : 'store'}}.</p>
                    </div>
                    <div class="common addcompanymain marginbottomsamesec" *ngFor = "let payment of transactions">
                        <div class="caddtitle d-none">
                           <!--  <p class="viewnorr viewnorroview">#00{{payment.transaction_id}}</p> -->
                            <!-- <p class="countnotification countnotificationoview text-right"><b>Total: ${{payment.license_count*payment.subscrition_amount}}</b><br/></p> -->
                        </div>
                        <div class="prodsubistsecmian">
                            <div class="prodsubistsec">
                                <img src="{{product_image_url}}{{payment.icon}}"/>
                                <div class="istsecontent">
                                    <h4>{{payment.name}}</h4>
                                    <a href="javascript:void(0)" routerLink = "/manage-subscriptions/{{payment.product_id}}">Manage subscriptions</a>
                                </div>
                            </div>
                            <!-- <div class="prodsubsecondsec">
                                <h4>Plan</h4>
                                <p>{{payment.package_name}} Plan, <span class="pyment_interval">{{payment.package_interval}}ly</span> payment</p>
                            </div>-->
                            <div class="prodsubsecondsec text-right float-right">
                                <h4>Licences</h4>
                                <p>{{payment.no_of_licenses}}</p>
                            </div> 
                        </div>
                        
                    </div>
                    
                </ng-template>

            </div>

        </div>
    

</div>